import {AxiosResponse} from 'axios'
import Client from 'core/api/client'
import {IanaTimezone} from 'core/utils/timezone'
import authHeaders from './authHeaders'
import { IStudyReviewerResult } from './getStudyReviewer'

interface IGetTechniciansResponseBody {
  technicians: IStudyReviewerResult[]
}

export interface IGetTechniciansResponse extends AxiosResponse {
  data: IGetTechniciansResponseBody
}

export function getTechnicians(token: string, reviewerId: string): Promise<IGetTechniciansResponse> {
  const url = `/study/reviewer/${reviewerId}/technicians`;
  return Client.get(url, { ...authHeaders(token), validateStatus: () => true });
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_reviewer/getTechnicians.ts